import React, { useState, useEffect } from 'react';
import './App.css';
import DogsFilter from "./components/DogsFilter"
import dogs from "./dogs";

function App() {

	/*const [data, setData] = useState([]);

	useEffect(() => {
		fetch("http://localhost:8000/api/dogs")
		.then((response) => response.json())
		.then((json) => setData(json))
	}, [])*/
	
  return (
    <div className="App">
      <DogsFilter dogs={dogs}/>
    </div>
  );
}

export default App;
